'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var AUTOUPDATE_DOWNLOAD_START = exports.AUTOUPDATE_DOWNLOAD_START = 'AUTOUPDATE_DOWNLOAD_START';
var AUTOUPDATE_DOWNLOAD_COMPLETE = exports.AUTOUPDATE_DOWNLOAD_COMPLETE = 'AUTOUPDATE_DOWNLOAD_COMPLETE';
var AUTOUPDATE_UPDATE_INSTALL = exports.AUTOUPDATE_UPDATE_INSTALL = 'AUTOUPDATE_UPDATE_INSTALL';

var AUTOUPDATE_CHECK_START = exports.AUTOUPDATE_CHECK_START = 'AUTOUPDATE_CHECK_START';
var AUTOUPDATE_CHECK_COMPLETE = exports.AUTOUPDATE_CHECK_COMPLETE = 'AUTOUPDATE_CHECK_COMPLETE';

var AUTOUPDATE_FORCE_POLL = exports.AUTOUPDATE_FORCE_POLL = 'AUTOUPDATE_FORCE_POLL';
var AUTOUPDATE_ERROR = exports.AUTOUPDATE_ERROR = 'AUTOUPDATE_ERROR';

var ELECTRON_APP_SLEEP = exports.ELECTRON_APP_SLEEP = 'ELECTRON_APP_SLEEP';
var ELECTRON_APP_WAKE = exports.ELECTRON_APP_WAKE = 'ELECTRON_APP_WAKE';

var AUTOUPDATE_STATE = exports.AUTOUPDATE_STATE = {
    NONE: undefined,
    CHECKING: 'CHECKING',
    DOWNLOADING: 'DOWNLOADING',
    READY: 'READY',
    ERROR: 'ERROR'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/electron/electronConstants.js
// module id = 321
// module chunks = 0